import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgWaveform = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M6.125 10.5v7a.875.875 0 1 1-1.75 0v-7a.875.875 0 1 1 1.75 0Zm3.5-7.875a.875.875 0 0 0-.875.875v21a.875.875 0 1 0 1.75 0v-21a.875.875 0 0 0-.875-.875ZM14 6.125a.875.875 0 0 0-.875.875v14a.875.875 0 1 0 1.75 0V7A.875.875 0 0 0 14 6.125Zm4.375 3.5a.875.875 0 0 0-.875.875v7a.875.875 0 1 0 1.75 0v-7a.875.875 0 0 0-.875-.875Zm4.375-1.75a.875.875 0 0 0-.875.875v10.5a.875.875 0 1 0 1.75 0V8.75a.875.875 0 0 0-.875-.875Z" />
  </svg>
);
export default SvgWaveform;
